module.exports = __webpack_public_path__ + "static/media/phone-icon.34046aa4.svg";